/**
 * @generated SignedSource<<b36ef7f05b3c733a42bfc7706d2c9dec>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultLayoutContainerSellerLastUsedToolFragment$data = {
  readonly sellerLastUsedTool: number;
  readonly " $fragmentType": "defaultLayoutContainerSellerLastUsedToolFragment";
};
export type defaultLayoutContainerSellerLastUsedToolFragment$key = {
  readonly " $data"?: defaultLayoutContainerSellerLastUsedToolFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultLayoutContainerSellerLastUsedToolFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultLayoutContainerSellerLastUsedToolFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sellerLastUsedTool",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ddb4f162320feba575ba1f2301e6c36f";

export default node;
